angular.module('tf.directives')

    .directive('userSelector', function () {
        return{
            restrict:'E',
            replace:true,
            scope:{
                role            : '@?',
                not             : '@?',
                allowNew        : '@?',
                placeholder     : '@?',
                users           : '=?',
                groups          : '=?',
                newUsers        : '=?',
                availableUsers  : '=?',
                availableGroups : '=?'
            },
            templateUrl:'js/components/userSelector/userSelector.html',
            link: function(scope,element,attr){

                var groupsLabel = 'Groups';
                var usersLabel = 'Users';
                scope.placeholder = scope.placeholder || 'Enter email addresses';

                function validateEmail(email) {
                    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return re.test(email);
                }

                scope.selected = {
                    items : []
                };

                scope.available = [];
                scope.availableUsers = scope.availableUsers || [];
                scope.availableGroups = scope.availableGroups || [];




                scope.getLabel = function(item){
                    if (item.local) {
                        return usersLabel;
                    } else if(item.members) {
                        return groupsLabel;
                    }
                    return undefined;
                };

                scope.groupBy = function(item) {
                    if(!scope.availableUsers || !scope.availableUsers.length || !scope.availableGroups || !scope.availableGroups.length){
                        return undefined;
                    }
                    return scope.getLabel(item);
                };
                scope.$watchCollection("selected.items", function(vals){
                    scope.users = [];
                    scope.groups = [];
                    scope.newUsers = [];
                    _.each(vals, function(item){
                        if(scope.getLabel(item) === usersLabel){
                            scope.users.push(item);
                        } else if (scope.getLabel(item) === groupsLabel){
                            scope.groups.push(item);
                        } else if(validateEmail(item)){
                            scope.newUsers.push(item);
                        }
                    });
                }, true);

                scope.$watchGroup(['availableUsers', 'availableGroups'], function(newVal){
                    scope.available = _.reduce(newVal,function(memo,val){
                        if(val){
                            return memo.concat(val);
                        }
                        return memo;
                    },[]);
                });

            }
        };
    })

    .directive('uiSelectCustom', [function() {
        return {
            require: '^uiSelect',
            restrict: 'A',
            link: function(scope, element, attrs, $select) {

                function validateEmail(email) {
                    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return re.test(email);
                }



                scope.onSelect = function($item){
                    if($select.tagging.isActivated && !validateEmail($item)){
                        $select.selected.splice($select.selected.length-1,1);
                    } else {
                        var searchInput = element.querySelectorAll('input.ui-select-search');
                        searchInput.val('');
                    }
                };
                scope.onOpenClose = function(){
                    setTimeout(function(){
                        $select.activeIndex = -1;
                    },0);
                };

                var searchInput = element.querySelectorAll('input.ui-select-search');

                searchInput.on('blur', function() {
                    scope.$apply(function() {
                        var val = searchInput.val();
                        if(validateEmail(val) && scope.allowNew){
                            $select.select(val);
                        }
                    });
                });

                searchInput.on('focus', function() {
                    scope.$apply(function() {

                    });

                });

            }
        };
    }])

    ;


